/** @format */

import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Inject, input, PLATFORM_ID } from '@angular/core';

@Component({
	selector: 'pdp-highlights',
	templateUrl: './highlights.component.html',
	styleUrl: './highlights.component.scss',
	imports: [CommonModule],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class HighlightsComponent {
	items = input<string[]>([]);

	constructor(@Inject(PLATFORM_ID) protected platformId: object) {}

	trackByFn(index: number, item: string): string {
		return index.toString() + item;
	}
}
